import { render, staticRenderFns } from "./StaticReadOnly.vue?vue&type=template&id=2f4916aa"
import script from "./StaticReadOnly.vue?vue&type=script&lang=js"
export * from "./StaticReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports